import { atom } from "recoil";

export const valueSearchJobsNameAtoms = atom({
  default: "",
  key: "valueSearchJobsNameAtoms",
});

export const valueSearchJobsDivisionAtoms = atom({
  default: "",
  key: "valueSearchJobsDivisionAtoms",
});

export const valueSearchJobStatusAtoms = atom({
  default: null,
  key: "valueSearchJobStatusAtoms",
});

export const valueInputOpportunity = atom({
  default: {
    title: "",
    description: "",
    location_id: "",
    division_id: "",
    job_level: "",
  },
  key: "valueInputOpportunity",
});

export const valueInputJobDescAtoms = atom({
  default: [{ job_description: "" }],
  key: "valueInputJobDescAtoms",
});

export const valueInputJobRequirementAtoms = atom({
  default: [{ job_requirement: "" }],
  key: "valueInputJobRequirementAtoms",
});

export const valueUseRef = atom({
  default: null,
  key: "valueUseRef",
});
